import React from 'react';
import { Checkbox, Select, FormControl, MenuItem, Input, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { lexSort, getSelectedGeographies, upsertSelectedMetric } from '../../../helpers';
import { MetricsTableStyles } from './MetricsTableStyles';
import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';
import Track from '../../../helpers/Analytics';

const GeographyPicker = ({ metric, selectedMetrics, onMetricsSelected, classes }) => {
  if (metric.geographies.length === 0) return;
  const sortedGeographies = metric.geographies.sort((a, b) => lexSort(a.name, b.name));
  const selectedGeographies = getSelectedGeographies(
    selectedMetrics.find(sm => sm.id === metric.id),
    metric.geographies
  );
  const selectedGeoIds = selectedGeographies.map(sg => sg.id);
  const checkedGeoIds = selectedGeographies.filter(sg => sg.selected).map(sg => sg.id);
  const selectedGeoName = selectedGeographies && selectedGeographies.length === 1 ? selectedGeographies[0].name : 'Add';
  return (
    <FormControl>
      <Select
        multiple
        disableUnderline
        aria-label='pick geography'
        displayEmpty
        classes={{
          icon: clsx('fa fa-angle-down', classes.MetricsTable_geographyPickerIcon),
          root: classes.MetricsTable_geographyPicker,
          select: classes.MetricsTable_geographyPickerSelect
        }}
        value={checkedGeoIds}
        renderValue={() => selectedGeoName}
        IconComponent={Icon}
        onChange={event =>
          onMetricsSelected(
            upsertSelectedMetric(
              metric,
              {
                geographies: [...new Set([...event.target.value, ...selectedGeoIds])].map(sg => ({
                  selected: !!event.target.value.find(v => v === sg),
                  id: sg,
                  name: metric.geographies.find(g => g.geographyId === sg).name
                }))
              },
              selectedMetrics,
              true
            )
          )
        }
        input={<Input id='select-geography' />}
      >
        {sortedGeographies.map(g => (
          <MenuItem key={g.geographyId} value={g.geographyId} className='geographyChoice'>
            <Checkbox
              checked={checkedGeoIds.indexOf(g.geographyId) > -1}
              icon={<span className={classes.icon} />}
              checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
              onChange={() => Track('Metric',  { id: "Geo-Toggle", metric: metric.name, geo: g.name, checked: !checkedGeoIds.indexOf(g.geographyId) > -1 })}
            />
            <ListItemText primary={g.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default withStyles(MetricsTableStyles)(GeographyPicker);
